import { genStyleHook } from '../../__builtins__';
import { getAnimationStyle } from './animation';
import { getGridStyle } from './grid';
import { genOtherStyle } from './other';
var genSmallStyle = function (token) {
    var _a, _b, _c, _d, _e, _f;
    var componentCls = token.componentCls, antCls = token.antCls, controlHeightSM = token.controlHeightSM, marginLG = token.marginLG, fontSizeSM = token.fontSizeSM, lineHeightSM = token.lineHeightSM;
    return _a = {
            fontSize: fontSizeSM,
            lineHeight: controlHeightSM
        },
        _a["".concat(componentCls, "-label")] = {
            lineHeight: "".concat(controlHeightSM, "px"),
            minHeight: controlHeightSM - 4,
            '> label': {
                height: controlHeightSM - 2,
            },
        },
        _a["".concat(componentCls, "-control-content")] = {
            ' &-component': {
                minHeight: controlHeightSM - 4,
                lineHeight: lineHeightSM,
            },
        },
        _a["".concat(componentCls, "-help,\n      ").concat(componentCls, "-extra")] = {
            minHeight: controlHeightSM - 4,
            lineHeight: "".concat(controlHeightSM - 4, "px"),
        },
        _a["".concat(componentCls, "-control-content")] = {
            minHeight: controlHeightSM - 4,
        },
        _a["".concat(antCls, "-input-affix-wrapper,\n      ").concat(antCls, "-input-number,\n      ").concat(antCls, "-picker")] = {
            padding: "0px 11px",
            input: {
                height: controlHeightSM - 4,
                fontSize: fontSizeSM,
            },
        },
        _a["".concat(antCls, "-cascader-picker")] = {
            height: controlHeightSM - 4,
            input: {
                padding: '0 7px',
                height: controlHeightSM - 4,
                fontSize: fontSizeSM,
            },
        },
        _a["".concat(antCls, "-select-single:not(").concat(antCls, "-select-customize-input) ").concat(antCls, "-select-selector")] = (_b = {
                padding: "0px 11px",
                height: controlHeightSM - 4,
                fontSize: fontSizeSM,
                lineHeight: "".concat(controlHeightSM, "px")
            },
            _b["".concat(antCls, "-select-selection-search")] = {
                height: controlHeightSM,
                lineHeight: "".concat(controlHeightSM - 4, "px"),
                '&-input': {
                    height: controlHeightSM - 4,
                    lineHeight: "".concat(controlHeightSM - 4, "px"),
                },
            },
            _b["".concat(antCls, "-select-selection-placeholder")] = {
                height: controlHeightSM,
                lineHeight: "".concat(controlHeightSM - 4, "px"),
            },
            _b["".concat(antCls, "-select-selection-item")] = {
                height: controlHeightSM,
                lineHeight: "".concat(controlHeightSM - 4, "px"),
            },
            _b["".concat(antCls, "-select-multiple:not(").concat(antCls, "-select-customize-input)\n          ").concat(antCls, "-select-selector")] = (_c = {
                    padding: '0px 2px',
                    height: controlHeightSM - 4,
                    fontSize: fontSizeSM,
                    lineHeight: "".concat(controlHeightSM, "px"),
                    '&::after': {
                        height: controlHeightSM - 8,
                        lineHeight: "".concat(controlHeightSM - 8, "px"),
                    }
                },
                _c["".concat(antCls, "-select-selection-search")] = {
                    height: controlHeightSM - 8,
                    lineHeight: "".concat(controlHeightSM - 8, "px"),
                    marginInlineStart: 0,
                    '&-input': {
                        height: controlHeightSM,
                        lineHeight: "".concat(controlHeightSM - 4, "px"),
                    },
                },
                _c["".concat(antCls, "-select-selection-placeholder")] = {
                    height: controlHeightSM - 4,
                    lineHeight: "".concat(controlHeightSM, "px"),
                    marginInlineStart: 4,
                },
                _c["".concat(antCls, "-select-selection-overflow-item")] = (_d = {
                        alignSelf: 'flex-start'
                    },
                    _d["".concat(antCls, "-select-selection-item")] = {
                        lineHeight: "".concat(controlHeightSM - 10, "px"),
                        height: controlHeightSM - 8,
                    },
                    _d),
                _c),
            _b["&".concat(componentCls, "-feedback-layout-terse")] = (_e = {
                    marginBottom: 8
                },
                _e["&".concat(componentCls, "-feedback-has-text:not(").concat(componentCls, "-inset)")] = {
                    marginBottom: 0,
                },
                _e),
            _b["&".concat(componentCls, "-feedback-layout-loose")] = (_f = {
                    marginBottom: marginLG
                },
                _f["&".concat(componentCls, "-feedback-has-text:not(").concat(componentCls, "-inset)")] = {
                    marginBottom: 0,
                },
                _f),
            _b),
        _a;
};
var genLargeStyle = function (token) {
    var _a, _b, _c, _d, _e, _f;
    var componentCls = token.componentCls, antCls = token.antCls, fontSizeLG = token.fontSizeLG, controlHeightLG = token.controlHeightLG, controlHeightSM = token.controlHeightSM, marginLG = token.marginLG, lineHeightLG = token.lineHeightLG;
    return _a = {
            fontSize: fontSizeLG,
            lineHeight: "".concat(controlHeightLG, "px")
        },
        _a["".concat(componentCls, "-label")] = {
            lineHeight: "".concat(controlHeightLG, "px"),
            minHeight: controlHeightLG - 2,
            '> label': {
                height: controlHeightLG,
            },
        },
        _a["".concat(componentCls, "-control-content")] = {
            ' &-component': {
                minHeight: controlHeightLG - 2,
                lineHeight: lineHeightLG,
            },
        },
        _a["".concat(componentCls, "-help,\n      ").concat(componentCls, "-extra")] = {
            minHeight: controlHeightSM,
            lineHeight: "".concat(controlHeightSM, "px"),
        },
        _a["".concat(componentCls, "-control-content")] = {
            minHeight: controlHeightLG - 2,
        },
        _a["".concat(antCls, "-input")] = {
            fontSize: fontSizeLG,
        },
        _a["".concat(antCls, "-input-number")] = {
            fontSize: fontSizeLG,
            input: {
                height: controlHeightLG - 2,
            },
        },
        _a["".concat(antCls, "-input-affix-wrapper,\n      ").concat(antCls, "-picker")] = {
            padding: "0px 11px",
            lineHeight: "".concat(controlHeightLG - 2, "px"),
            input: {
                height: controlHeightLG - 2,
                fontSize: fontSizeLG,
            },
        },
        _a["".concat(antCls, "-btn")] = {
            height: controlHeightLG,
            padding: '0 8px',
        },
        _a["".concat(antCls, "-radio-button-wrapper")] = {
            height: controlHeightLG,
            lineHeight: "".concat(controlHeightLG, "px"),
        },
        _a["".concat(antCls, "-cascader-picker")] = {
            height: controlHeightLG - 2,
            input: {
                padding: '0 11px',
                height: controlHeightLG - 2,
                fontSize: fontSizeLG,
            },
        },
        _a["".concat(antCls, "-select-single:not(").concat(antCls, "-select-customize-input) ").concat(antCls, "-select-selector")] = (_b = {
                padding: "0px 11px",
                height: controlHeightLG,
                fontSize: fontSizeLG,
                lineHeight: "".concat(controlHeightLG, "px")
            },
            _b["".concat(antCls, "-select-selection-search")] = {
                height: controlHeightLG,
                lineHeight: "".concat(controlHeightLG - 2, "px"),
                '&-input': {
                    height: controlHeightLG,
                    lineHeight: "".concat(controlHeightLG - 2, "px"),
                },
            },
            _b["".concat(antCls, "-select-selection-placeholder")] = {
                height: controlHeightLG,
                lineHeight: "".concat(controlHeightLG, "px"),
            },
            _b["".concat(antCls, "-select-selection-item")] = {
                height: controlHeightLG,
                lineHeight: "".concat(controlHeightLG, "px"),
            },
            _b["".concat(antCls, "-select-multiple:not(").concat(antCls, "-select-customize-input)\n          ").concat(antCls, "-select-selector")] = (_c = {
                    padding: '0px 2px',
                    height: controlHeightLG - 2,
                    fontSize: fontSizeLG,
                    lineHeight: "".concat(controlHeightLG, "px"),
                    '&::after': {
                        height: controlHeightLG - 8,
                        lineHeight: "".concat(controlHeightLG - 8, "px"),
                    }
                },
                _c["".concat(antCls, "-select-selection-search")] = {
                    height: controlHeightLG - 8,
                    lineHeight: "".concat(controlHeightLG - 8, "px"),
                    '&-input': {
                        height: controlHeightLG - 12,
                        lineHeight: "".concat(controlHeightLG - 12, "px"),
                    },
                },
                _c["".concat(antCls, "-select-selection-placeholder")] = {
                    height: controlHeightLG - 8,
                    lineHeight: "".concat(controlHeightLG - 8, "px"),
                },
                _c["".concat(antCls, "-select-selection-overflow-item")] = (_d = {
                        alignSelf: 'flex-start'
                    },
                    _d["".concat(antCls, "-select-selection-item")] = {
                        lineHeight: "".concat(controlHeightLG - 10, "px"),
                        height: controlHeightLG - 8,
                    },
                    _d),
                _c),
            _b["&".concat(componentCls, "-feedback-layout-terse")] = (_e = {
                    marginBottom: 8
                },
                _e["&".concat(componentCls, "-feedback-has-text:not(").concat(componentCls, "-inset)")] = {
                    marginBottom: 0,
                },
                _e),
            _b["&".concat(componentCls, "-feedback-layout-loose")] = (_f = {
                    marginBottom: marginLG
                },
                _f["&".concat(componentCls, "-feedback-has-text:not(").concat(componentCls, "-inset)")] = {
                    marginBottom: 0,
                },
                _f),
            _b),
        _a;
};
var genLabelStyle = function (token) {
    var _a, _b, _c;
    var componentCls = token.componentCls, controlHeight = token.controlHeight, controlHeightSM = token.controlHeightSM, marginLG = token.marginLG, marginSM = token.marginSM, lineHeight = token.lineHeight;
    return {
        lineHeight: "".concat(controlHeight, "px"),
        minHeight: controlHeight - 2,
        position: 'relative',
        display: 'flex',
        color: token.colorTextHeading,
        label: {
            cursor: 'text',
        },
        '&-content': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            label: {
                whiteSpace: 'nowrap',
            },
        },
        '&-tooltip': {
            cursor: 'help',
            '*': {
                cursor: 'help',
            },
            label: {
                borderBottom: '1px dashed currentColor',
            },
        },
        '&-feedback-layout': {
            '&-terse': {
                marginBottom: marginSM,
            },
            '&-loose': {
                marginBottom: marginLG,
            },
            '&-none': {
                marginBottom: 0,
            },
            '&-terse, &-loosee, &-none': (_a = {},
                _a["&.".concat(componentCls, "-feedback-has-text:not(").concat(componentCls, "-inset)")] = {
                    marginBottom: 0,
                },
                _a),
        },
        '&-control': (_b = {
                flex: 1,
                maxWidth: '100%'
            },
            _b["&.".concat(componentCls, "-control-content")] = (_c = {
                    display: 'flex',
                    '&-component': {
                        width: '100%',
                        minHeight: controlHeight - 2,
                        lineHeight: lineHeight,
                        '&-has-feedback-icon': {
                            flex: 1,
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                        },
                    }
                },
                _c["".concat(componentCls, "-addon")] = {
                    '&-before': {
                        marginInlineEnd: marginSM,
                    },
                    '&-after': {
                        marginInlineEnd: marginSM,
                    },
                    '&-before, &-after': {
                        display: 'inline-flex',
                        alignItems: 'center',
                        minHeight: controlHeight,
                        flexShrink: 0,
                    },
                },
                _c),
            _b["".concat(componentCls, "-help,\n        ").concat(componentCls, "-extra")] = {
                minHeight: controlHeightSM,
                lineHeight: "".concat(controlHeightSM, "px"),
                color: token.colorTextSecondary,
            },
            _b),
    };
};
var genFormItemStyle = function (token) {
    var _a, _b, _c, _d, _e, _f, _g;
    var componentCls = token.componentCls, fontSize = token.fontSize, marginLG = token.marginLG;
    return _a = {},
        _a[componentCls] = (_b = {
                display: 'flex',
                position: 'relative',
                marginBottom: marginLG,
                fontSize: fontSize
            },
            _b["".concat(componentCls, "-label")] = genLabelStyle(token),
            _b["&".concat(componentCls, "-size-small")] = genSmallStyle(token),
            _b["&".concat(componentCls, "-size-large")] = genLargeStyle(token),
            _b['&-label'] = (_c = {
                    '&-align': (_d = {},
                        _d["&-left"] = (_e = {},
                            _e["> ".concat(componentCls, "-label")] = {
                                justifyContent: 'flex-start',
                            },
                            _e),
                        _d["&-right"] = (_f = {},
                            _f["> ".concat(componentCls, "-label")] = {
                                justifyContent: 'flex-end',
                            },
                            _f),
                        _d)
                },
                _c['&-wrap'] = (_g = {},
                    _g["".concat(componentCls, "-label")] = {
                        label: {
                            whiteSpace: 'pre-line',
                            wordBreak: 'break-all',
                        },
                    },
                    _g),
                _c),
            _b),
        _a;
};
export default genStyleHook('Form', function (token) {
    return [
        genFormItemStyle(token),
        getAnimationStyle(token),
        genOtherStyle(token),
        getGridStyle(token),
    ];
});
//# sourceMappingURL=index.js.map